export default {
    RESET: 'BANK-ID/RESET',
    START_AUTH: 'BANK-ID/START_AUTH',
    IN_PROGRESS: 'BANK-ID/BANKID_IN_PROGRESS',
    COMPLETED: 'BANK-ID/BANKID_COMPLETED',
    SET_ERROR: 'BANK-ID/SET_ERROR',
    CLOSE: 'BANK-ID/CLOSE'
};
